import { atom } from 'jotai'

type Input = {
  isShow: boolean
  text: string | undefined
}

const state = atom<Input>({
  isShow: false,
  text: undefined,
})
export const notificationBarStore = { state } as const
